import axios from 'axios';
import ConfigService from './config.service';

interface GeneratePdfChecklistRequest {
    vesselImoNumber: string;
    port: string;
    classNumber: string;
    eta: string;
    vesselName: string;
}

const generateChecklistPdf = async (request: GeneratePdfChecklistRequest): Promise<Blob> => {
    try {
        request.vesselImoNumber = request.vesselImoNumber.replace('/', '');
        const res = await axios.post(`${ConfigService.appConfig.baseApiUrl}/Checklist/GeneratePdfChecklist`, request, {
            responseType: 'blob'
        });
        return res.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('Axios error:', error.message);
            throw new Error(error.response?.data || 'Network Error');
        } else {
            console.error('Unexpected error:', error);
            throw new Error('An unexpected error occurred');
        }
    }
};

const ChecklistService = {
    generateChecklistPdf
};

export default ChecklistService;
